import { signOut } from 'aws-amplify/auth';

export default defineNuxtRouteMiddleware(async (to) => {
  const routes = useRouter();

  if ('logout' in to.query) {
    await signOut();

    const { logout: _, ...query } = to.query;
    routes.replace({ query });
    reloadNuxtApp();
  }
});
